import type { ModelApiKey } from '~/types/models'
import type { PagerNeighbors } from '~/types/collection-pager'

export function useCollectionPager(model: ModelApiKey, slug: string) {
  return useFetch<PagerNeighbors>(
    `/api/__collection-pager__/${encodeURIComponent(model)}/${encodeURIComponent(slug)}`,
    {
      default: (): PagerNeighbors => ({ prev: null, next: null }),
      onResponseError({ response }) {
        console.error('[CollectionPager] Request failed:', response.status, response.url)
      }
    }
  )
}
